import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import React from 'react';

import {
  BaseCollapseButtonLeftRoot,
  BaseCollapseButtonRightRoot,
} from './BaseCollapseButton.styled';

export const collapseButtonState = {
  right: 'right',
  left: 'left',
};

const BaseCollapseButton = ({
  onClick,
  active,
  state = collapseButtonState.right,
}) => {
  return state === collapseButtonState.right ? (
    <BaseCollapseButtonRightRoot onClick={onClick}>
      {active ? <ChevronRightIcon /> : <ChevronLeftIcon />}
    </BaseCollapseButtonRightRoot>
  ) : (
    <BaseCollapseButtonLeftRoot onClick={onClick}>
      {active ? <ChevronLeftIcon /> : <ChevronRightIcon />}
    </BaseCollapseButtonLeftRoot>
  );
};

export default BaseCollapseButton;
